import { Entity } from '@core/data/dto/entity';
import { CourierVehicleType } from '../courier/courier-vehicle-type';
import { DeliveryOrderQuoteManagerStatus } from './delivery-order-quote-manager-status';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { Dto } from '@core/data/dto/dto';
import { DeliveryOrderQuoteManagerSchema } from './delivery-order-quote-manager.schema';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';

export class DeliveryOrderQuoteManager implements Entity {
    public id: string;
    public avatarUrl: string;
    public config: boolean;
    public vehicleType: CourierVehicleType;
    public timecardId: string;
    public timecardStatus: DeliveryOrderQuoteManagerStatus;
    public name: string;

    @DtoImport(DeliveryOrderQuoteManagerSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderQuoteManagerSchema,
        },
    ])
    export(type?: DtoType): any {}
}
